import type { CanvasTarget } from '../types';

// Making a new App, as Skills make one (`canvas=skill&id=new`): a new chat with the App panel waiting beside it. The
// chat stays ordinary chat, where App building lives, so this is presentation only: the chip, the welcome words and
// the App ideas read it from the open canvas. The thread's first App preview replaces this panel in place
// (apps/preview/tool-output.ts, appPreviewOpening), so the build appears where the person is already looking.
export const NEW_APP_CANVAS: CanvasTarget = { kind: 'app-preview', id: 'new' };

export const isNewAppCanvas = (canvas: CanvasTarget | null | undefined): boolean =>
  canvas?.kind === 'app-preview' && canvas.id === NEW_APP_CANVAS.id;
